export default "/assets/images/rocket.c7d266c0b986dbd0.png";